// 甘孜市场（/ganzi）
// 内容框架：左侧「常见的牦牛 / 牦牛酪蛋白产业园（入园企业产值）」+ 中间地图切换（与奶渣原料地距离 /
// 牦牛数量分布 / 中国牦牛分布 / 炉霍产业园）+ 右侧（牦牛乳相关弹窗 + 乡村振兴 + 十五五规划）。
// 部分数据（typeData / nutrition / distance / 地图等）来自后台 ganzi.json，本模块接管页面静态文案与
// 硬编码在页内的数组（入园企业、乡村振兴、十五五规划投资分布）。
export default {
  title: '甘孜市场',
  groups: [
    {
      title: '页头与区块标题',
      fields: [
        { key: 'headCommonYak', label: '区块标题·常见的牦牛', type: 'text', default: '常见的牦牛' },
        { key: 'headParkOverview', label: '区块标题·入园企业产值总览', type: 'text', default: '入园企业2026年产值总览' },
        { key: 'headDistance', label: '标题·炉霍工厂与奶渣原料地距离', type: 'text', default: '炉霍工厂与奶渣原料地距离' },
        { key: 'headYakDist', label: '标题·牦牛数量分布', type: 'text', default: '牦牛数量分布' },
        { key: 'headChinaYak', label: '标题·中国牦牛数量分布', type: 'text', default: '中国牦牛数量分布' },
        { key: 'headRural', label: '区块标题·乡村振兴', type: 'text', default: '乡村振兴' },
        { key: 'headPlan15', label: '区块标题·十五五规划', type: 'text', default: '十五五规划' },
      ],
    },
    {
      title: '中间地图切换按钮',
      fields: [
        { key: 'btnDistance', label: '按钮·炉霍工厂与奶渣原料地距离', type: 'text', default: '炉霍工厂与奶渣原料地距离' },
        { key: 'btnYakDist', label: '按钮·牦牛数量分布', type: 'text', default: '牦牛数量分布' },
        { key: 'btnPark', label: '按钮·牦牛酪蛋白产业园', type: 'text', default: '牦牛酪蛋白产业园' },
        { key: 'btnChain', label: '按钮·酪蛋白产业链数字化', type: 'text', default: '酪蛋白产业链数字化' },
      ],
    },
    {
      title: '右侧入口按钮与弹窗标题',
      fields: [
        { key: 'btnNutrition', label: '按钮/弹窗·牦牛乳的相关产品及成分', type: 'text', default: '牦牛乳的相关产品及成分' },
        { key: 'btnBuy', label: '按钮/弹窗·购买食物所考虑的因素', type: 'text', default: '购买食物所考虑的因素' },
        { key: 'btnStandard', label: '按钮/弹窗·酪蛋白的企业标准及视频', type: 'text', default: '酪蛋白的企业标准及视频' },
        { key: 'linkQula', label: '链接·曲拉回收可视化数据实时监控', type: 'text', default: '曲拉回收可视化数据实时监控' },
      ],
    },
    {
      title: '入园企业产值',
      fields: [
        { key: 'parkHeadCompany', label: '表头·入园企业', type: 'text', default: '入园企业' },
        { key: 'parkHeadValue', label: '表头·2026年产值', type: 'text', default: '2026年产值' },
        { key: 'parkHeadPct', label: '表头·占比', type: 'text', default: '占比' },
        { key: 'siteLabel', label: '企业官网链接文字', type: 'text', default: '🌐 官网 ↗' },
        { key: 'unitWan', label: '单位·万', type: 'text', default: '万' },
        { key: 'parkDesc', label: '园区产业闭环说明', type: 'textarea', default: '园区构建牦牛加工、日化深加工、数字赋能、电商销售、环保配套、文旅宣传完整产业链闭环，凸显对炉霍县域经济、乡村振兴的支撑价值。' },
        { key: 'parkSummary', label: '园区2026年产值综述', type: 'textarea', default: '园区2026年总产值 2631 万元，产业结构层次清晰：以牦牛加工为主的第二产业产值 2431 万元（其中康巴圣德 2165 万元、创智环保 266 万元），占园区经济主体；数字科技服务等现代服务业产值 200 万元，拓宽产品外销与产业升级路径。完整闭环产业链持续壮大县域特色产业，有效带动群众增收，强力支撑炉霍乡村振兴与地方经济发展。' },
      ],
    },
    {
      title: '乡村振兴',
      fields: [
        { key: 'ruralDirectJobs', label: '子标题·直接带动就业', type: 'text', default: '直接带动就业' },
        { key: 'ruralIncomeTitle', label: '子标题·人均收入', type: 'text', default: '人均收入' },
        { key: 'ruralIndirectJobs', label: '子标题·间接带动就业', type: 'text', default: '间接带动就业' },
        { key: 'ruralCoop', label: '子标题·带动合作社', type: 'text', default: '带动合作社' },
        { key: 'unitYear', label: '单位·年', type: 'text', default: '年' },
        { key: 'unitYuan', label: '单位·元', type: 'text', default: '元' },
        { key: 'unitAbove', label: '单位·个以上', type: 'text', default: '个以上' },
        { key: 'incomeSummaryPre', label: '人均收入综述·前缀', type: 'text', default: '人均收入：' },
        { key: 'incomeSummaryNum', label: '人均收入综述·数值', type: 'text', default: '4,152' },
        { key: 'incomeSummaryUnit', label: '人均收入综述·单位', type: 'text', default: ' 元' },
        { key: 'coopName1', label: '合作社1·名称', type: 'text', default: '炉霍县呷托牦牛养殖农民专业合作社' },
        { key: 'coopLabel1', label: '合作社1·产值标签', type: 'text', default: '2026年产值（截至7月）' },
        { key: 'coopValue1', label: '合作社1·产值', type: 'text', default: '470.00' },
        { key: 'coopName2', label: '合作社2·名称', type: 'text', default: '炉霍县霍尔牧兴牦牛养殖农民专业合作社' },
      ],
    },
    {
      title: '十五五规划',
      fields: [
        { key: 'planLandLabel', label: '园区工业用地标签', type: 'text', default: '园区工业用地（自有）' },
        { key: 'planLandValue', label: '园区工业用地面积', type: 'text', default: '48' },
        { key: 'unitMu', label: '单位·亩', type: 'text', default: '亩' },
      ],
    },
    {
      title: '入园企业详情弹层',
      fields: [
        { key: 'coClose', label: '弹层·返回按钮', type: 'text', default: '✕ 返回园区' },
        { key: 'secIntro', label: '弹层板块·公司/协会介绍', type: 'text', default: '公司/协会介绍' },
        { key: 'secPositioning', label: '弹层板块·品牌定位', type: 'text', default: '品牌定位' },
        { key: 'secBiz', label: '弹层板块·核心业务板块', type: 'text', default: '核心业务板块' },
        { key: 'coChartTitle', label: '弹层图表标题·核心量化数据', type: 'text', default: '核心量化数据' },
        { key: 'secProjects', label: '弹层板块·落地项目清单', type: 'text', default: '落地项目清单' },
        { key: 'secAdv', label: '弹层板块·核心竞争优势', type: 'text', default: '核心竞争优势' },
        { key: 'secPlan', label: '弹层板块·发展规划', type: 'text', default: '发展规划' },
        { key: 'planShort', label: '规划·短期', type: 'text', default: '短期规划（1-2年）' },
        { key: 'planMid', label: '规划·中期', type: 'text', default: '中期规划（3-5年）' },
        { key: 'planLong', label: '规划·长期', type: 'text', default: '长期规划（5年以上）' },
        { key: 'companyFooter', label: '弹层底部说明', type: 'text', default: '甘孜州牦牛酪蛋白产业园 · 入园企业展示 · 数据来源：6家公司设计规划' },
      ],
    },
    {
      title: '数据指标（直接编辑当前值）',
      fields: [
        { key: 'parkCompanies', label: '入园企业2026年产值（万元）', type: 'array', default: [
          { name: '康巴圣德牦牛产业有限公司', value: 2165, pct: '82.3', color: '#FFD942', lead: true, website: 'https://www.casein-industry.com/' },
          { name: '甘孜州川妤生物科技有限公司', value: 0, pct: '0.0', color: '#42AAFF' },
          { name: '甘孜州康创未来数字科技有限公司', value: 200, pct: '7.6', color: '#0CFBFF' },
          { name: '甘孜州雪域三千传媒有限公司', value: 0, pct: '0.0', color: '#5B8FF9' },
          { name: '甘孜州章谷臻品电子商务有限公司', value: 0, pct: '0.0', color: '#3CB0FF' },
          { name: '炉霍创智环保设备制造有限公司', value: 266, pct: '10.1', color: '#2A54A2' },
          { name: '炉霍县互联网文化旅游推广协会', value: 0, pct: '0.0', color: '#8B5CF6' },
        ] },
        { key: 'ruralJobs', label: '乡村振兴·直接带动就业岗位（2023-2025）', type: 'array', default: [
          { year: '2023', value: 22 },
          { year: '2024', value: 25 },
          { year: '2025', value: 26 },
        ] },
        { key: 'ruralIncome', label: '乡村振兴·人均收入（2023-2025，元）', type: 'array', default: [
          { year: '2023', value: 3900, pct: 93.8 },
          { year: '2024', value: 4160, pct: 100 },
          { year: '2025', value: 4152, pct: 99.8 },
        ] },
        { key: 'ruralIndirect', label: '乡村振兴·间接带动就业（2023-2025）', type: 'array', default: [
          { year: '2023', value: '100', active: false },
          { year: '2024', value: '200', active: true },
          { year: '2025', value: '200', active: true },
        ] },
        { key: 'plan15Data', label: '十五五规划·投资分布（万元）', type: 'array', default: [
          { name: '户外直播和园区文旅基地打造', value: 200, no: '01', color: '#00F0FF' },
          { name: '园区道路及形象优化', value: 100, no: '02', color: '#00D8E8' },
          { name: '酪蛋白生产线固定资产', value: 3000, no: '03', color: '#00C0D1' },
          { name: '园区配套锅炉及环保设施', value: 500, no: '04', color: '#00A8BA' },
          { name: '原料渠道建设', value: 200, no: '05', color: '#0090A3' },
          { name: '原料收购铺底流动资金', value: 1800, no: '06', color: '#00788C' },
          { name: '新建博士工作站', value: 300, no: '07', color: '#006070' },
          { name: '新生产线及园区数字化改造', value: 1900, no: '08', color: '#004858' },
        ] },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认背景，留空用系统底图）', type: 'image', default: '' },
      ],
    },
  ],
}
